import ForgotPassword from './ForgotPassword.jsx'

export default ForgotPassword
